// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
	
	
			
} )();




$(document).ready(function(){


	AOS.init();
	
	$('.owl-carousel').owlCarousel({
		loop:true,
		margin:10,
		nav:true,
		dots:true,
		responsive:{
		    0:{
		        items:1
		    },
		    600:{
		        items:1
		    },
		    1000:{
		        items:2
		    }
		}    
	}); 
  

  
	// init Masonry
	var $grid = $('.grid').masonry({
	  itemSelector: '.grid-item',
	  percentPosition: true,
	  columnWidth: '.grid-sizer'
	});
	// layout Masonry after each image loads
	$grid.imagesLoaded().progress( function() {
	  $grid.masonry();
	});  
  

	// Sticky Menu
	$(window).scroll(function(){
	  var sticky = $('#header'),
	      scroll = $(window).scrollTop();
	
	  if (scroll >= 320) sticky.addClass('affix');
	  else sticky.removeClass('affix');
	});
	
	// RGPD Cookies
	$(window).load(function(){
		if(localStorage.getItem('hjcookie') != '0221'){
	    	setTimeout(function() { 
        	$('#rgpd').addClass( 'active' );
    		}, 2000);
			localStorage.setItem('hjcookie','0221');
	  	}
	});
	
	$('#rgpd_exit').click(function(e) { 
	    $('#rgpd').removeClass( 'active' );
	});
	
	
	
  
});// Jquery ready